import styled from 'styled-components';

export const Container = styled.div`
  font-family: 'Sora', sans-serif;
  padding: 50px;
  display: flex;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.white};

  * {
    letter-spacing: 0px;
    line-height: initial;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoints.xxl}px) {
    padding: 30px;
  }

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
    padding: 20px;
  }
`;

export const Wrapper = styled.div`
  max-width: 1500px;
  width: 100%;
  position: relative;

  > header {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    padding-bottom: 10px;
    gap: 20px;

    @media only screen and (max-width: ${({ theme }) =>
        theme.breakpoints.lg}px) {
      flex-direction: column;
      align-items: stretch;
      text-align: left;
    }

    h1 {
      font-weight: 700;
      color: ${({ theme }) => theme.colors.black};
      font-size: 28px;
      letter-spacing: 0px;
    }

    h3 {
      color: ${({ theme }) => theme.colors.grey};
      font-weight: 400;
      padding-top: 5px;
    }
  }
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.lg}px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const MonthSelect = styled.div`
  display: flex;
  flex-direction: column;

  label {
    font-size: 13px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.grey};
    padding-bottom: 6px;
  }

  .react-datepicker-wrapper input {
    font-family: 'Sora', sans-serif;
    font-size: 15px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.softBlack};
    border: 3px solid ${({ theme }) => theme.colors.lightGrey};
    border-radius: 5px;
    padding: 12px 15px;
    background-color: ${({ theme }) => theme.colors.white};
    cursor: pointer;
    text-align: center;
    width: 160px;
  }
`;

export const DownloadButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Sora', sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.main};
  border: none;
  border-radius: 5px;
  padding: 14px 22px;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  svg {
    font-size: 18px;
  }
`;

export const Cards = styled.main`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 30px;
  padding-top: 30px;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoints.xxl}px) {
    grid-gap: 20px;
  }

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
    grid-gap: 20px;
    grid-template-columns: repeat(2, 1fr);
  }

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const CardItem = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 150px;
  padding: 20px;
  border: 3px solid ${({ theme }) => theme.colors.lightGrey};
  border-radius: 5px;

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    svg {
      font-size: 24px;
    }

    h2 {
      font-size: 15px;
      font-weight: 700;
      color: ${({ theme }) => theme.colors.grey};
    }
  }

  main {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 14px 0 6px;

    h3 {
      font-weight: 700;
      color: ${({ theme }) => theme.colors.softBlack};
      font-size: 38px;
    }
  }

  footer {
    span {
      font-size: 13px;
      color: ${({ theme }) => theme.colors.grey};
    }
  }
`;

export const Value = styled.h3`
  color: ${({ theme }) => theme.colors.softBlack} !important;
`;

export const StatusList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`;

export const StatusBadge = styled.span<{
  cor: 'verde' | 'vermelho' | 'amarelo' | 'cinza';
}>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 700;
  padding: 5px 12px;
  border-radius: 20px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme, cor }) => {
    if (cor === 'verde') return theme.colors.green;
    if (cor === 'vermelho') return theme.colors.red;
    if (cor === 'amarelo') return theme.colors.orange;
    return theme.colors.grey;
  }};
`;

export const Aviso = styled.p`
  margin-top: 24px;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.grey};
`;

export const LoadingContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 80px;
`;
